/* eslint-disable */
const loadMoreScroll = btn => {
	let dataCountPosts = btn.parentElement.getAttribute('data-count-posts');
	let arrPosts = [];
	$('.news-blog-article').each(function () {
		arrPosts.push($(this).attr('data-post-id'));
	});

	let data = {
		action: "sendify_scroll_load_more",
		page: themeVars.current_page,
		posts: arrPosts,
		nonce: themeVars.ajax_more_nonce,
	};
	$.ajax({
		url: themeVars.ajaxurl,
		data: data,
		type: "POST",
		beforeSend: function () {
			$(".load-container").addClass("disabled");
		},

		success: function (data) {
			if (data) {
				$(data).appendTo($(".load-more-posts-ajax"));
				$(".load-container").removeClass("disabled");
				themeVars.current_page++;
				const length = $('.news-blog-article').length;

				if (dataCountPosts <= length) {
					$(".load-container").hide();
				} else {
					$(".load-container").show();
				}
			}
		},
	});
};
export default loadMoreScroll;



// WEBPACK FOOTER //
// ./scripts/modules/load-more-scroll.js